import React, { useState, useContext } from "react";

import PlusIcon from "../../icons/plus-icon";
import FeesIcon from "../../icons/fees-icon";
import BalanceIcon from "../../icons/balance-icon";

import { PopUpContext } from "../../contexts/popUpContext";

import lbl from "../../data/Labels.json";

const FabButtons = ({ cache }) => {
  const [open, setOpen] = useState(false);
  const { togglePopUp } = useContext(PopUpContext);

  return (
    <div className={`fab-container ${open ? "active" : ""}`} style={{paddingLeft: 0, width: open ? "150px" : "50px"}}>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "teacher-balance-form", cache })}
      >
        <BalanceIcon />
        <span>{lbl.OpeningBalance}</span>
      </button>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "teacher-payment-form", cache })}
      >
        <FeesIcon />
        <span>{lbl.Payment}</span>
      </button>
      <button className="primary" onClick={() => setOpen(!open)}>
        <PlusIcon />
        <span>{lbl.Cancel}</span>
      </button>
    </div>
  );
};

export default FabButtons;
